import classNames from 'classnames'
import type { StatusTone } from '@/types/domain'
import styles from './style.module.css'

export interface ChipOption {
  value: string
  label: string
  tone?: StatusTone
}

interface ChipSelectProps {
  options: ChipOption[]
  value: string[]
  onChange: (value: string[]) => void
  ariaLabel?: string
  disabled?: boolean
}

const ChipSelect = ({ ariaLabel, disabled = false, onChange, options, value }: ChipSelectProps) => {
  const alternar = (opcao: string) => {
    onChange(value.includes(opcao) ? value.filter((item) => item !== opcao) : [...value, opcao])
  }

  return (
    <div className={styles.wrapper} role="group" aria-label={ariaLabel}>
      {options.map((option) => {
        const ativo = value.includes(option.value)

        return (
          <button
            key={option.value}
            type="button"
            className={classNames(styles.chip, { [styles.ativo]: ativo })}
            onClick={() => alternar(option.value)}
            aria-pressed={ativo}
            disabled={disabled}
          >
            {option.tone ? (
              <span className={classNames(styles.dot, styles[option.tone])} aria-hidden />
            ) : null}
            {option.label}
          </button>
        )
      })}
    </div>
  )
}

export default ChipSelect
